import classNames from 'classnames';
import * as React from 'react';

import * as IBooks from '../../../../../../../interfaces/merchants/resources/books';
import BooksCalendarHeader from '../BooksCalendarHeader';
import BooksCalendarTimeTable from '../BooksCalendarTimeTable';

import css from './BooksCalendar.module.scss';

interface Props {
  loading: boolean;
  postable: boolean;
  dates: string[];
  events: {
    checkinTimes: string[];
    dates: { [date: string]: IBooks.DateTimeSlot };
  };
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const BooksCalendar = ({
  loading,
  postable,
  dates,
  events,
  onClick,
}: Props) => {
  const classes = classNames(css.BooksCalendar);

  return (
    <div className={classes}>
      <BooksCalendarHeader dates={dates} />
      <BooksCalendarTimeTable
        loading={loading}
        postable={postable}
        events={events}
        onClick={onClick}
      />
    </div>
  );
};

export default BooksCalendar;
